<template>
  <div>
    <v-simple-table>
      <thead>
        <tr>
          <th class="text-left">Produto</th>
          <th class="text-left">Quantidade</th>
          <th class="text-left">Unidade</th>
          <th class="text-left">Valor Unitário</th>
          <th class="text-left">ICMS</th>
          <th class="text-left">IPI</th>
          <th class="text-left">Valor Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in notaFiscal.produtos" :key="item.id">
          <td>
            {{ item.descricao }}
            <p class="caption mb-0">
              SKU: {{ item.skuVendedor }} | NCM: {{ item.ncm }} | CFOP: {{ item.cfop }}
            </p>
          </td>
          <td>{{ item.quantidade }}</td>
          <td>{{ item.unidadeComercial }}</td>
          <td>{{ item.precoUnitario | currency }}</td>
          <td>{{ item.valorIcms | currency }} - {{ item.percentualIcms | number('0.00') }}%</td>
          <td>
            {{ item.valorIpi || 0 | currency }} - {{ item.percentualIpi || 0 | number('0.00') }}%
          </td>
          <td>{{ item.precoTotal | currency }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  props: {
    notaFiscal: {
      type: Object,
      required: true,
    },
  },
};
</script>
